import { Action } from 'redux';
import { BffCmsFaqResponse } from '@lucky7ventures/bff-types';

export enum FaqActionType {
  GetFaq = 'GET_FAQ',
  GetFaqSuccess = 'GET_FAQ_SUCCESS',
  GetFaqError = 'GET_FAQ_ERROR',
}

export type GetFaqAction = Action<FaqActionType.GetFaq>;
export type GetFaqSuccessAction = Action<FaqActionType.GetFaqSuccess> & {
  faq: BffCmsFaqResponse;
};
export type GetFaqErrorAction = Action<FaqActionType.GetFaqError>;

export type FaqActions = GetFaqAction | GetFaqSuccessAction | GetFaqErrorAction;

export const getFaq = (): GetFaqAction => ({
  type: FaqActionType.GetFaq,
});

export const getFaqSuccess = (faq: BffCmsFaqResponse): GetFaqSuccessAction => ({
  type: FaqActionType.GetFaqSuccess,
  faq,
});

export const getFaqError = (): GetFaqErrorAction => ({
  type: FaqActionType.GetFaqError,
});
